/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PageInfoDto } from '../models/page-info-dto';
import { pigControllerCountByProductId } from '../fn/pig/pig-controller-count-by-product-id';
import { PigControllerCountByProductId$Params } from '../fn/pig/pig-controller-count-by-product-id';
import { pigControllerCreate } from '../fn/pig/pig-controller-create';
import { PigControllerCreate$Params } from '../fn/pig/pig-controller-create';
import { pigControllerDelete } from '../fn/pig/pig-controller-delete';
import { PigControllerDelete$Params } from '../fn/pig/pig-controller-delete';
import { pigControllerFindById } from '../fn/pig/pig-controller-find-by-id';
import { PigControllerFindById$Params } from '../fn/pig/pig-controller-find-by-id';
import { pigControllerSearch } from '../fn/pig/pig-controller-search';
import { PigControllerSearch$Params } from '../fn/pig/pig-controller-search';
import { pigControllerUpdate } from '../fn/pig/pig-controller-update';
import { PigControllerUpdate$Params } from '../fn/pig/pig-controller-update';
import { PigDto } from '../models/pig-dto';

@Injectable({ providedIn: 'root' })
export class PigService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `pigControllerSearch()` */
  static readonly PigControllerSearchPath = '/api/pig';

  /**
   * 돼지 목록 조회.
   *
   * 돼지 목록을 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pigControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  pigControllerSearch$Response(params: PigControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<PigDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = pigControllerSearch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 돼지 목록 조회.
   *
   * 돼지 목록을 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pigControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pigControllerSearch(params: PigControllerSearch$Params, context?: HttpContext): Observable<{
'items': Array<PigDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.pigControllerSearch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<PigDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<PigDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `pigControllerCreate()` */
  static readonly PigControllerCreatePath = '/api/pig';

  /**
   * 돼지 등록.
   *
   * 새로운 돼지를 등록합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pigControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pigControllerCreate$Response(params: PigControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<PigDto>> {
    const obs = pigControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 돼지 등록.
   *
   * 새로운 돼지를 등록합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pigControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pigControllerCreate(params: PigControllerCreate$Params, context?: HttpContext): Observable<PigDto> {
    const resp = this.pigControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PigDto>): PigDto => r.body)
    );
  }

  /** Path part for operation `pigControllerFindById()` */
  static readonly PigControllerFindByIdPath = '/api/pig/{id}';

  /**
   * 돼지 상세 조회.
   *
   * 돼지를 ID로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pigControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  pigControllerFindById$Response(params: PigControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<PigDto>> {
    const obs = pigControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 돼지 상세 조회.
   *
   * 돼지를 ID로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pigControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pigControllerFindById(params: PigControllerFindById$Params, context?: HttpContext): Observable<PigDto> {
    const resp = this.pigControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PigDto>): PigDto => r.body)
    );
  }

  /** Path part for operation `pigControllerDelete()` */
  static readonly PigControllerDeletePath = '/api/pig/{id}';

  /**
   * 돼지 삭제.
   *
   * 돼지를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pigControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  pigControllerDelete$Response(params: PigControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<PigDto>> {
    const obs = pigControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 돼지 삭제.
   *
   * 돼지를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pigControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pigControllerDelete(params: PigControllerDelete$Params, context?: HttpContext): Observable<PigDto> {
    const resp = this.pigControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PigDto>): PigDto => r.body)
    );
  }

  /** Path part for operation `pigControllerUpdate()` */
  static readonly PigControllerUpdatePath = '/api/pig/{id}';

  /**
   * 돼지 수정.
   *
   * 돼지 정보를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pigControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pigControllerUpdate$Response(params: PigControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<PigDto>> {
    const obs = pigControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 돼지 수정.
   *
   * 돼지 정보를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pigControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pigControllerUpdate(params: PigControllerUpdate$Params, context?: HttpContext): Observable<PigDto> {
    const resp = this.pigControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PigDto>): PigDto => r.body)
    );
  }

  /** Path part for operation `pigControllerCountByProductId()` */
  static readonly PigControllerCountByProductIdPath = '/api/pig/count/{productId}';

  /**
   * 상품별 돼지 수 조회.
   *
   * 특정 상품에 속한 돼지 수를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pigControllerCountByProductId()` instead.
   *
   * This method doesn't expect any request body.
   */
  pigControllerCountByProductId$Response(params: PigControllerCountByProductId$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = pigControllerCountByProductId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품별 돼지 수 조회.
   *
   * 특정 상품에 속한 돼지 수를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pigControllerCountByProductId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pigControllerCountByProductId(params: PigControllerCountByProductId$Params, context?: HttpContext): Observable<void> {
    const resp = this.pigControllerCountByProductId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
